import "./cabin-class-card.scss";
import { ReactComponent as NextIcon } from "../../../assets/icons/klm/chevron-right-S.svg";
import { ReactComponent as CheckMark } from "../../../assets/icons/check-S.svg";
import CloseIcon from "@mui/icons-material/Close";

const CabinClassCard = ({ imgUrl, cabinClass, cabinClassModal }) => {
  const handleOnClick = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="cabin-class-card">
      <img
        className="cabin-card-img"
        src={imgUrl.file.url}
        alt={imgUrl.title}
      />
      <div className="cabin-card-title">
        <span className="class-title">{cabinClass.title}</span>
      </div>
      <div className="cabin-card-body">
        <h5 className="card-body-title">
          {cabinClassModal.includePerPassenger}
        </h5>
        <div className="card-body-content">
          {cabinClass.services.map((service, index) => (
            <div key={index} className="card-body-item">
              {service.selected ? (
                <CheckMark className="card-body-icon-checkmark" />
              ) : (
                <CloseIcon className="card-body-icon-x" />
              )}
              <div key={index} className="card-body-description">
                {service.description}
              </div>
            </div>
          ))}
        </div>
      </div>
      <button
        className="cabin-class-button"
        onClick={() => handleOnClick(cabinClass.infoUrl)}
      >
        <span className="compare-class-text">
          {cabinClassModal.moreInfoButton}
        </span>
        <NextIcon className="back-icon" />
      </button>
    </div>
  );
};

export default CabinClassCard;
